module.exports = __webpack_public_path__ + "img/qgbqs-s2_32-50.prt.3f086670.jpg";